import { Cell } from '@pelckmans/elementis/components/table';
import ItemFilter from '../ItemFilter';
import { useTranslation } from 'react-i18next';
import { useContext } from 'react';
import { HorizontalScrollContext } from '../../../../context/HorizontalScrollContextProvider';
import renderStudent from '../../../../utils/render-student';
import { TocNodeRowHeader } from '../../hooks/useTableData';
import { useFilters } from '../../../../context/filter-context/FilterContext';

interface Props {
  nodeRowGroups: TocNodeRowHeader[];
}

export default function MultiMemberTableHead({ nodeRowGroups }: Props) {
  const { t } = useTranslation();
  const { horizontalScroll } = useContext(HorizontalScrollContext);
  const { selectedMembers, selectedGroups } = useFilters();

  if (!selectedGroups.length) return null;

  const membersToShow = selectedMembers[selectedGroups[0].id] || [];

  return (
    <thead>
      <tr>
        <Cell.Header
          className="scorable-item-column"
          title={t('PAGES.RESULTS.PER_STUDENT.TABLE.HEADER.TITLE')}
          sticky={horizontalScroll}
        >
          <ItemFilter nodeRowGroups={nodeRowGroups} />
        </Cell.Header>
        {membersToShow.map(member => (
          <Cell.Header className="result-column" key={member.id} title={renderStudent(member)} />
        ))}
      </tr>
    </thead>
  );
}
